{
  "error": "Error",
  "loading": "...",
  "newUser": "Nuevo usuario",
  "newUserGroup": "Nuevo grupo"
}
